export default __webpack_public_path__ + "static/media/gamefi_05.7906044e.png";